import React from "react"
import styled, { keyframes } from "styled-components"
import * as vars from "../style/vars"
import { below, above, clearFix } from "../style/functions"
import Link from "gatsby-link"
import LogoSvg from "../svg/logo"
import DownSvg from "../svg/down-arrow"
import shader from "shader"
import HamburgerMenu from "react-hamburger-menu"
import Fb from "../svg/facebook.svg"
import MenuChild from "../components/menuChild"
import Insta from "../svg/instagram.svg"

import AppIco from "../svg/ico-yarrabend-residents-app.svg"
class HeaderMobileNav extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         dropped: false,
         theme: "dark",
         mobShown: false,
         isIE: null,
         enquiry: false,
         menu: null,
         nowSellingStatus: 'false'
      }
   }

   componentDidMount() {
      if (typeof window !== `undefined`) {
         let dropdowns = document.querySelectorAll(".dropdown .icon")
         dropdowns.forEach(function (elem) {
            elem.addEventListener("click", function (event) {
               event.preventDefault()
               // console.log(elem.parentElement)
               elem.parentElement.classList.toggle("dropped")
            })
         })
         let links = document.querySelectorAll("header a")
         links.forEach(
            function (elem) {
               elem.addEventListener(
                  "click",
                  function () {
                     // console.log(this.state.mobShown)
                     document.querySelector("body").classList.remove("fixed")

                     if (elem.getAttribute("href") == "/enquire") {
                        document.getElementById('wrapper').className = "enquire";
                     } else {
                        document.getElementById('wrapper').className = "";
                     }

                     this.setState({ mobShown: false })
                  }.bind(this)
               )
            }.bind(this)
         )
         this.setState({ isIE: /*@cc_on!@*/ false || !!document.documentMode })

         if (this.props.custom) {
            this.setState({ theme: "dark" })
         } else {
            this.setState({ theme: this.props.theme })
         }
         if (this.props.menu) {
            this.setState({ menu: this.props.menu.nav })
         }

         if (typeof window !== `undefined`) {
            if (window.location.pathname == '/artisan/artisan-residences' || window.location.pathname == '/artisan/artisan--culinary-house' || window.location.pathname == '/parkview/parkview-apartments' || window.location.pathname == '/parkview/parkview-houses' || window.location.pathname == '/the-mills/the-mills-townhouses') {
               this.setState({ nowSellingStatus: 'active' });
            }
            window.addEventListener(
               "scroll",
               function () {
                  if (window.scrollY > window.innerHeight) {
                     this.setState({ enquiry: true })
                  } else {
                     this.setState({ enquiry: false })
                  }
               }.bind(this)
            )
         }
      }
   }
   toggleMob() {



      document.querySelector("body").classList.toggle("fixed")
      document.querySelector("header").classList.toggle("fixed")
      let mobShown = !this.state.mobShown

      if (mobShown) {
         document.body.style.overflow = 'hidden';
         window.scrollTo({
            top: 0,
            behavior: "smooth"
         })
      }else{
         document.body.style.overflow = 'unset';
      }


      this.setState({ mobShown })
   }

   render() {
      const menu = this.props.menu.nav;
      const allMenu = []


      menu.map((menu_item, i) => {
         const label = menu_item.primary.label.text
         const link = menu_item.primary.link.text
         const children = []

         menu_item.items.map((child_menu_item, i) => {
            const label = child_menu_item.sub_nav_link_label.text
            const link = child_menu_item.sub_nav_link.text
            if (link != null) {
               children.push({ id: i, label, link })
            }
         })

         var dropdown_class = ""
         var main_class = ""

         if (children.length > 0) {
            dropdown_class = ' dropdown '
         }

         if (i == 0) {
            main_class = ' main '
         }

         allMenu.push({ id: i, label, link, children, dropdown_class, main_class })

         return allMenu
      })

      // console.log(allMenu);

      return (
         <div>
            <Container
               theme={this.state.theme}
               dropped={this.state.dropped}
               custom={this.props.custom}
               className={"theme-" + this.state.theme}>
               <div className="grid">
                  <div className="inner">
                     {this.state.isIE === false ? (
                        <Hamburger theme={this.state.theme}>
                           <HamburgerMenu
                              isOpen={this.state.mobShown}
                              menuClicked={this.toggleMob.bind(this)}
                              width={39}
                              height={22}
                              strokeWidth={2}
                              color={vars.colors.blank}
                              animationDuration={vars.time}
                           />
                        </Hamburger>
                     ) : (
                           ""
                        )}

                     <Logo to="/" title="YarraBend">
                        <LogoSvg />
                     </Logo>
                     <Nav theme={this.state.theme} isOpen={this.state.mobShown}>
                        <ul>
                           {
                              allMenu.map((item, i) => {
                                 if (item.dropdown_class != '' && i == 0) {

                                    return (
                                       <li className={item.dropdown_class + '' + item.main_class}
                                         >
                                          {
                                             //if internal check
                                                /^\/(?!\/)/.test(item.link) === true
                                                ?
                                                <A activeClassName="active" className={this.state.nowSellingStatus} to={item.link} title="">
                                                   <i>{item.label}</i>
                                                </A>

                                                :
                                                <a activeClassName="active"  href={item.link}  target="_blank"><i>{item.label}</i></a>
                                          }
                                          <span className="icon" />
                                          <MenuChild data={item.children}></MenuChild>
                                       </li>
                                    )
                                 } else if (item.dropdown_class != '') {

                                    return (
                                       <li className={item.dropdown_class + '' + item.main_class}
                                          >
                                          {
                                          //if internal check
                                          /^\/(?!\/)/.test(item.link) === true
                                          ?
                                          <A activeClassName="active" to={item.link} title="">
                                             <i>{item.label}</i>
                                          </A>

                                          :
                                          <a activeClassName="active"  href={item.link}  target="_blank"><i>{item.label}</i></a>
                                          }
                                          <span className="icon" />
                                          <MenuChild data={item.children}></MenuChild>
                                       </li>
                                    )
                                 } else {
                                    return (
                                       <li>
                                          {
                                          //if internal check
                                          /^\/(?!\/)/.test(item.link) === true
                                          ?
                                          <A activeClassName="active" to={item.link} title="">
                                             <i>{item.label}</i>
                                          </A>

                                          :
                                          <a activeClassName="active"  href={item.link}  target="_blank"><i>{item.label}</i></a>
                                          }
                                       </li>
                                    )
                                 }
                              })
                           }
                           <li className='mobileOnly'>
                              <a  href="https://app.propertyshell.com/auth/default/login"  target="_blank"><i>Agent Login</i></a>
                           </li>
                        </ul>




                     </Nav>
                     <ActionWrapper>
                     <AgentLink>
                        <a href="https://app.propertyshell.com/auth/default/login" target="_blank">
                        Agent Login
                        </a>
                        </AgentLink>

                     <Social>
                           <a href="https://www.facebook.com/yarrabend" target="_blank">
                              <img src={Fb} alt="Glenvill logo" />
                           </a>
                           <a href="https://www.instagram.com/yarrabend_/" target="_blank">
                              <img src={Insta} alt="Glenvill logo" />
                           </a>
                           <a href="/yarrabend-residents-app/">
                              <img src={AppIco} alt="YarraBend Residents App icon" />
                           </a>
                        </Social>
                        { this.props.hideEnquire ?
                           ''
                           :
                           <EnquireBadge className="pull-right" onClick={e => {this.props.togglePopup();}}>
                              <span>
                                 Enquire Now
                              </span>

                           </EnquireBadge>
                        }
                     </ActionWrapper>
                  </div>
               </div>
               <div className="overlay" />
            </Container>
            <EnquireBanner visi={this.state.enquiry}>
               <Link to="/" className="yarrabend-logo">
                  <LogoSvg />
               </Link>
            </EnquireBanner>
         </div>
      )
   }
}

const AgentLink = styled.div`
float: right;
font-size: 1.3rem;

font-size: 1.3rem;
position: absolute;
right: 58px;
top: 44px;
white-space: nowrap;

${above.giant`
font-size: 1.3rem;
    position: absolute;
    right: 30px;
    top: 62px;
`}

${below.mid`
right: 0;

   `}
${below.desktop`
top: 22px;
font-size: 1.1rem;
`}

${below.tablet`
      display: none;
   `}

`

const Container = styled.header`
   position: relative;
   z-index: 100;
   top: 0;
   left: 0;
   right: 0;

   padding-bottom: 19px;
   ${above.l`
   padding-bottom: 21px;
   `}

	 .grid .inner{

    }


   ${props =>
      props.theme == "light" &&
      `
      background: ${vars.colors.offColor};
   `}
   ${props =>
      props.theme == "dark" &&
      `
      background: ${vars.colors.body};
      color: ${vars.colors.blank};
   `}
   ${props =>
      props.theme == "trans" &&
      `
      background: none;
      position: absolute;
      left: 0;
      right: 0;
      color: ${vars.colors.blank};
   `}
   ${props =>
      props.theme == "trans" &&
      below.tablet`
      background: ${vars.colors.body};
   `};

      &.fixed{
         position: fixed;
         background: ${vars.colors.body};
      }

   ${below.tablet`
      position: fixed;
      padding-top: ${vars.padding.tabInner}rem;
      padding-bottom: ${vars.padding.tabInner}rem;

   `}
   ${below.mobile`
      padding-top: ${vars.padding.mobInner}rem;
      padding-bottom: ${vars.padding.mobInner}rem;
   `}

   .overlay {
      position: absolute;
      background: linear-gradient(to bottom, ${vars.colors.offColor} 0%,${
   vars.colors.offColor
   } 42%,rgba(0,0,0,0) 100%);
      z-index: 99;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100vh;
      visibility: hidden;
      transform: translateY(-100%);
      ${props =>
      props.theme == "dark" &&
      `
         background: linear-gradient(to bottom, ${vars.colors.body} 0%,${
      vars.colors.body
      } 20%,rgba(0,0,0,0) 100%);
      `}
      ${props =>
      props.theme == "trans" &&
      `
         background: linear-gradient(to bottom, ${vars.colors.body} 0%,${
      vars.colors.body
      } 10%,rgba(0,0,0,0) 100%);
      `}
      transition: ${vars.time * 1.5}s transform ease-in-out, ${vars.time *
   1.5}s visibility ease-in-out;
      ${props =>
      props.dropped &&
      `
         transform: translateY(0%);
         visibility: visible;
         opacity: 1;
      `}

      ${below.tablet`
         visibility: hidden ;
         transform: translateY(-100%);
         opacity: 0 ;
      `};
   }

   ${props =>
      props.custom &&
      `
      background: ${props.custom};
   .overlay {
      background: linear-gradient(to bottom, ${props.custom} 0%,${
      props.custom
      } 10%,rgba(0, 0, 0, 0) 100%);
   }

   `}
`

const Social = styled.div`
     float: right;
	 	margin-top:39px;
		 margin-right:138px;
		 margin-left: 15px;
		 ${above.giant`
	 	margin-top: 59px;
		 `}
		 ${below.mid`
    margin-right: 0;
    margin-right: 80px;
	 margin-left: 0px;

		 `}
		 ${below.desktop`
             margin-top: 14px;
             display:none;
		 `}
      a {
         margin: 0 0.2rem;
      }

      img {
         height: 23px;
         width: 23px;
      }
`

const Hamburger = styled.div`
display: block;
   float: left;
   cursor: pointer;
   margin-top: 1rem;


   ${above.desktop`
   margin-top: 0.4rem;
   `}

   span {
      ${props =>
      props.theme == "light" &&
      `
         background: ${vars.colors.body} !important;
      `};
      ${props =>
      props.theme == "white" &&
      `
         background: ${vars.colors.body} !important;
      `};
   }
   ${below.tablet`
      display: block;
   `} ${below.mobile`
      margin-top: 0.2rem;
      div {
         width: 2.574rem !important;
         height: 1.452rem !important;
         span {
            height: 1px !important;
         }
      }
   `};
`
const ActionWrapper = styled.div`
   position:absolute;
   top:-5rem;
   right: 3.5rem;

   ${below.desktop`
      top:-2rem;
   `}
`
const Nav = styled.nav`
   ${clearFix()};

   .mobileOnly{
      display:none;
   }

   ${below.tablet`

   .mobileOnly{
      display:block;
   }
   `}

   position: relative;
   z-index: 100;


   overflow-y:scroll;
   -webkit-overflow-scrolling: touch;
      visibility: hidden;
      position: fixed;
      background: ${vars.colors.body};
      left:-100vw;
      width: 100vw;
      height: 100%;
      transition: left ${vars.time}s ease-in-out, visibility ${vars.time}s ease-in-out;
      margin-top:18px;
      ${props =>
         props.theme == "light" &&
         `
         background: ${vars.colors.offColor};
      `}
      ${props =>
         props.theme == "white" &&
         `
         background: ${vars.colors.blank};
      `}
      * { border-left: none !important;}
      ${props =>
         props.isOpen &&
         `
         visibility: visible;
         left: 0;
      `}

   ${below.mobile`
      margin-top:9px;

   `};
   padding-bottom:100px;

   ul {
      list-style: none;
      margin-left: 0;
      max-width: 100%;
      ${clearFix}
      display: block;
      padding-bottom:0;
      display:inline-block;



         width: 100%;
         float: none;


      &:hover {
         li {
            opacity: 0.6;

               opacity: 1;

         }
      }
      li {
         list-style: none;
         padding-bottom:0;
         display: block;
         float: left;
         opacity: 1;
         border-left: 2px solid rgba(0,0,0,0);
         transition: ${vars.time}s opacity ease-in-out, ${vars.time *
   1.5}s border-left ease-in-out;
				 &.main i{
					 background: #fff;
					 text-transform: uppercase;
					 padding: 5px 10px;
					 color: #313130;
				 }

            float: none;
            position: relative;
            &:first-of-type {
               a {
                  border-top: 1px solid ${shader(vars.colors.body, +0.2)} }
               }

         &.dropdown {

               position: relative;


            .icon {

                  transition: transform ${vars.time}s ease;
                  content: '';
                  display:block;
                  height: 50px;
                  width: 50px;
                  position: absolute;
                  right: 15px;
                  top: 50%;
                  transform: translateY(-50%);
                  background-image: url('/svg/arrow-right-white.svg');

            }
            &.dropped .icon{
               transform: rotate(90deg);
            }
         }
         a {
            text-decoration:none;
            text-transform: uppercase;
            font-weight: normal;
            font-size: 1.3rem;
            padding-top: 6rem;
            // margin-right: 2rem;
            padding-bottom: 4.5rem;
            padding-left: 1rem;
            padding-right: 1rem;
            display: block;
            transition:  ${vars.time}s border-top ease-in-out, ${vars.time}s color ease-in-out, ${vars.time}s border-top-color ease-in-out;
            font-size: 1.8rem;
            padding-left: 2rem;
            padding-right: 2rem;
            padding-top: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid ${shader(vars.colors.body, +0.2)};

            ${below.giant`
            font-size: 1.8rem;
            padding-left: 2rem;
            padding-right: 2rem;
            padding-top: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid ${shader(vars.colors.body, +0.2)};
            `}
            ${below.l`
            font-size: 1.8rem;
            padding-left: 2rem;
            padding-right: 2rem;
            padding-top: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid ${shader(vars.colors.body, +0.2)};
            `}
            ${below.desktop`
            font-size: 1.8rem;
            padding-left: 2rem;
            padding-right: 2rem;
            padding-top: 2rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid ${shader(vars.colors.body, +0.2)};
            `}
            ${below.tablet`
               font-size: 1.8rem;
               padding-left: 2rem;
               padding-right: 2rem;
               padding-top: 2rem;
               padding-bottom: 2rem;
               border-bottom: 1px solid ${shader(vars.colors.body, +0.2)};
               `}
            &.active {
               border-top: 0.6rem solid ${vars.colors.body};

               padding-left: 2rem;
               padding-right: 2rem;
               padding-top: 1.6rem;
               padding-bottom: 1.6rem;

                  border-top: none;
                  background:  ${shader(vars.colors.body, +0.2)};

               .theme-dark &, .theme-trans & {
                  border-top-color: ${vars.colors.blank};
               }
            }
         }

         &:hover{
            opacity: 1;
         }

         ul {
            display: block;
            text-align: left;
            visibility: hidden;
            opacity: 0;
            transition: ${vars.time * 1.5}s visibility ease-in-out, ${vars.time *
   1.5}s opacity ease-in-out;
            position: absolute;
            color: ${vars.colors.body};
            z-index: 101;
            margin-left: -2px;
            border-left-width: 2px;
            border-left-style: solid;
            border-image: linear-gradient(to bottom, ${
   vars.colors.body
   }, rgba(0, 0, 0, 0)) 1 100%;

            .theme-dark &, .theme-trans & {
               border-image: linear-gradient(to bottom, ${
   vars.colors.blank
   }, rgba(0, 0, 0, 0)) 1 100%;
               color: ${vars.colors.blank};
            }

               visibility: visible;
               opacity: 1;
               position: relative;
               border: none;
               background:  ${shader(vars.colors.body, +0.1)};
               overflow: hidden;
               max-height: 0;
               transition-property: all;
               transition-duration: ${vars.time}s;
               transition-timing-function: cubic-bezier(0, 1, 2, 1);


            li {
               float: none;

                  border: none;

               a {
                  font-family: ${vars.fonts.feature};
                  font-weight: normal;
                  font-size:3.2rem;
                  text-transform: none;
                  padding-bottom:2rem;
                  padding-top: 0;
                  transition: ${vars.time}s opacity ease-in-out;
                  opacity: 1;
                  &:hover {
                     opacity: 0.4;
                  }
									&.active{

										border-top: none;
										opacity: 0.7;
									}
                  // ${below.l`
                  //    font-size:2.8rem;
                  // `}

                     font-size: 1.6rem;
                     padding-left: ${vars.padding.mobInner * 2}rem;
                     padding-right: 2rem;
                     padding-top: 1.6rem;
                     padding-bottom: 1.6rem;
                     border-bottom: 1px solid ${vars.colors.blank};
                     font-family: ${vars.fonts.main};
                     text-transform: uppercase;
                     color: ${vars.colors.blank};


               }
            }
         }
         &:hover {
            opacity: 1;

            &.dropdown {
               border-left: 2px solid ${vars.colors.body};

               .theme-dark &, .theme-trans & {
                  border-left: 2px solid ${vars.colors.blank};
               }
            }

            ul {
               visibility:visible;
               opacity: 1; 

               li {
                  opacity: 1;
                  border-left: 0;

                     border-left: 2px solid rgba(0,0,0,0);

               }
            }
         }

         &.dropped ul {
            max-height: 360px;
         }

         &:last-of-type a {
            margin-right: 0;
         }

      }
   }
`

const Logo = styled(Link)`
   width: 20rem;
   margin-top: 5rem;
   display:block;
   position: relative;
   z-index: 200;
   // float: left;
    margin-right: 3.3rem;
    margin-left: auto;
    margin-right: auto;

   ${below.l`
      width: 18rem;
      margin-top: 4.5rem;
   `}
   ${below.desktop`
      width: 15rem;
      margin-top: 2rem;
   `}

   ${below.tablet`

      float: none;
      margin: auto;
      width: 25rem;
`}
   ${below.mobile`
      width: 16.6rem;
   `}
`

const A = styled(Link)``

const EnquireBadge = styled.button`
cursor:pointer;
   width: 8.8rem;
   height: 8.8rem;
   background: ${vars.colors.body};
   color: ${vars.colors.blank};
   text-decoration: none;
   display: block;
   border-radius: 100%;
   text-transform: uppercase;
   font-size: 1.4rem;
   font-weight: normal;
   margin-top: 1.3rem;
   transition: ${vars.time * 2}s background ease-in-out;
	 position: relative;
	 text-align:center;
   span {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 53%;
      left:50%;
   }

   ${below.l`
      width: 6.5rem;
      height: 6.5rem;
      margin-top: 20px;
      // margin-right:13px;
      font-size: 1.2rem;
         span {
            top: 52%;
            left:50%;
         }
   `}

   ${below.mid`
      margin-right:13px;
   `}
	 ${below.desktop`
				 margin-top: 5px;
             font-size: 8px;
             margin-right:13px;
				 width: 5rem;
             height: 5rem;
             display: none;

	 `}
   ${below.tablet`
      display: none;
   `}
//     ${below.tablet`
//       display: block;
//       position: fixed;
//       top: 2px;
//       right: 2px;
//       visibility: visible;
//   `}
  ${below.mobile`
      border-radius: 10%;
      width: 6rem;
      height: 3.5rem;
      top: 1px;
      right: 3px;
      font-size: 1rem;
      margin-right:9px;
  `}
   .theme-dark &, .theme-trans & {
      background: ${vars.colors.blank};
      color: ${vars.colors.body};
   }
   .down {
      display: block;
      width: 1.8rem;
      height: 1.1rem;
      margin: auto;
      margin-top: 3px;
      ${below.l`
         display:none;
      `};
   }

   // &:hover {
   //    background: ${shader(vars.colors.body, +0.2)};
   //    .theme-dark &,
   //    .theme-trans & {
   //       background: ${shader(vars.colors.blank, -0.2)};
   //    }
   // }
`

const nudge = keyframes`
   0%, 20%, 50%, 80%, 100% {
      transform: translateX(0) rotate(-90deg);
   }
   40% {
      transform: translateX(15px) rotate(-90deg);
   }
   60% {
      transform: translateX(7px) rotate(-90deg);
   }
`

const EnquireBanner = styled.div`
   position: fixed;
   display: flex;
   justify-content: space-around;
   top: 0;
   left: 0;
   right: 0;
   background: ${vars.colors.blank};
   color: ${vars.colors.body};
   text-decoration: none;
   text-align: center;
   background: ${vars.colors.body};
   color: ${vars.colors.blank};
   z-index: 1000;
   transform: translateY(-200%);
   font-weight: normal;
   font-size: 1.8rem;
   letter-spacing: 0.1rem;
   transition: ${vars.time}s background ease-in-out, ${vars.time}s transform ease-in-out;
   box-shadow: 0px 10px 69px -2px rgba(0, 0, 0, 0.75);
   ${props =>
      props.visi &&
      `
      transform:translateY(0);
      `};

   ${below.tablet`
      // padding: ${vars.padding.inner / 3}rem;
      display: none;
      `}
   // &:hover {
   //    background: ${shader(vars.colors.body, +0.2)};
   // }

   .icon {
      text-decoration: none;
      padding: 1.2rem 0 0 0;
      svg {
         width: 1.5rem;
         height: 1rem;
         margin-left: 1rem;
         top: -2px;
         position: relative;
         right: 0;
         display: inline-block;
         animation: ${nudge} 2s infinite;
         /* ${below.tablet`
            width: 1.6rem;
            height: 1rem;
            top: -1px;
         `} */
      }
   }


   .yarrabend-logo svg {
      /* float: left; */
      width: auto;
      height: 24px;
      margin: .7rem;
   }
`


export default HeaderMobileNav

// export const pageQuery = graphql`
// query {
//    prismicMainNavigation {
//      id
//      dataString
//      data {
//        display_name {
//          html
//          text
//        }
//        nav {
//          slice_type
//          primary {
//            label {
//              text
//            }
//            link {
//              text
//            }
//          }
//          items {
//            sub_nav_link_label {
//              text
//            }
//            sub_nav_link {
//              text
//            }
//          }
//        }
//      }
//    }
//  }
// `



// WEBPACK FOOTER //
// ./src/components/headerMobileNav.js